import qs from "qs";
import { initInputMask } from "@/components/inputMask";
import {
  Form,
  FormField,
  Input,
  Select,
  initRecapthaOnFormFocus,
} from "Components/form";
import { getNotification } from "Components/notification";

let firstFocusOnSomeForm = true;
class SerialNumbersForm extends Form {
  constructor(domElem) {
    super(domElem);
    this._initStore();
  }

  _setSerialNumberUsed(serialNumber = "", code = "") {
    const key = `${serialNumber}-${code}`;
    const store = this._getStore();
    store[key] = new Date().getTime();
    localStorage.setItem("snForm", JSON.stringify(store));
  }

  _getSerialNumberUsed(serialNumber = "", code = "") {
    if (!serialNumber) {
      return false;
    }
    const CACHE_TIME = 5 * 60 * 1000;
    const key = `${serialNumber}-${code}`;
    const store = this._getStore();
    let used = Object.keys(store).includes(key);
    if (used) {
      const diff = new Date().getTime() - store[key];
      used = diff < CACHE_TIME;
    }

    return used;
  }

  _getStore() {
    try {
      return JSON.parse(localStorage.getItem("snForm") ?? "{}");
    } catch (error) {
      localStorage.setItem("snForm", "{}");
      return {};
    }
  }

  _initStore() {
    localStorage.setItem("snForm", JSON.stringify(this._getStore()));
  }

  _onSubmit(e) {
    e.preventDefault();
    const values = this.getVal();
    const serialNumber = values["serialNum"] ?? "";
    const code = values["code"] ?? "";
    if (serialNumber) {
      if (this._getSerialNumberUsed(serialNumber, code)) {
        const notification = getNotification();
        const title = "Этот код уже был использован";
        const text =
          "Обратитесь в наш сервисный центр для консультации <a href='tel:+74950218805'>+74950218805</a>";

        this.hasMod("has-thanks") &&
          notification
            ?.setContent({
              title,
              content: text,
              status: "warning",
            })
            .show();
      } else {
        this._validation(this.getVal());
        this.getFields().some((field) => {
          return field.hasMod("invalid");
        }) || this._sendRequest();
        this._setSerialNumberUsed(serialNumber, code);
      }
    }
  }

  _sendRequest() {
    const xhr = new XMLHttpRequest(),
      domElem = this.domElem,
      data = new FormData(this.domElem);
    const method = (domElem.getAttribute("method") ?? "GET")
      .toString()
      .toUpperCase();
    let action = domElem.getAttribute("action");

    if (method === "GET") {
      const query = {};
      for (let [key, value] of data) {
        if (key === "serialNum" && value && typeof value === "string") {
          value = value.replace(/\D/g, "");
        }
        query[key] = value;
      }
      action = `${action}${action.includes("?") ? "&" : "?"}${qs.stringify(
        query
      )}`;
    }
    xhr.open(method, action);
    if (method === "GET") {
      xhr.setRequestHeader("Content-Type", "application/json");
    } else {
      xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    }
    xhr.onreadystatechange = (e) => {};
    xhr.send(method === "GET" ? null : data);

    xhr.onload = () => {
      this[xhr.status == 200 ? "_onSuccess" : "_onError"](xhr);
    };

    xhr.onerror = () => this._onError(xhr);
    this.domElem
      .querySelector(".button_type_submit")
      .classList.add("button_disabled");
  }

  static init() {
    document.querySelectorAll(`.${Form.className}`).forEach((formEl) => {
      if (formEl.id !== "form-check-sn") {
        formEl.addEventListener(
          "focus",
          (e) => {
            firstFocusOnSomeForm &&
              initRecapthaOnFormFocus(firstFocusOnSomeForm);
            firstFocusOnSomeForm && (firstFocusOnSomeForm = false);
          },
          true
        );
        return new Form(formEl);
      } else {
        return new SerialNumbersForm(formEl);
      }
    });
  }
}

export function initForms() {
  initInputMask();
  Input.init();
  Select.init();
  FormField.init();
  SerialNumbersForm.init();
}
